module.exports = __webpack_public_path__ + "static/img/11.d2ef486.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/4/1/zh/11.png
// module id = QOiC
// module chunks = 0